module.exports = __webpack_public_path__ + "img/地图@2x.42441ea1.png";